import moment from 'moment';
import momentTimezone from 'moment-timezone';

const FORMAT = 'YYYY/MM/DD hh:mm:ss A';
const DISPLAYFORMAT = 'MM/DD/YYYY hh:mmA';
const EDITFORMAT = 'YYYY-MM-DD HH:mm:ss ';

const formatTime = (time, zone) => {
  const momentObject = moment.tz(time, FORMAT, zone);
  momentObject.utc();
  return momentObject.format(FORMAT);
};

export const buildDbTime = (date, time, zone) => {
  const timeToFormat = momentTimezone
    .utc(date + 'T' + time)
    .format()
    .split('T')
    .join(' ')
    .slice(0, -1);
  return formatTime(timeToFormat, zone);
};

export const buildDisplayTime = (time, zone) => {
  const utcTime = moment.utc(time, DISPLAYFORMAT);
  const display = utcTime.tz(zone).format(DISPLAYFORMAT);
  return display;
};

export const buildEditTime = (time, zone) => {
  const utcTime = moment.utc(time, DISPLAYFORMAT);
  const display = utcTime.tz(zone).format(EDITFORMAT);
  const [date, clock] = display.split(' ');

  return [date, clock];
};



/** WEBPACK FOOTER **
 ** ./src/state/jobs/time-utils.js
 **/